import { useCallback, useState } from 'react'
import { Button } from 'antd'
import { KnownAddressModal } from './KnownAddressModal'

export type AddressName =
  | 'Delivery'
  | 'Dispatch'
  | 'Origin Site'
  | 'Facility Site'

export type KnownAddressResult = {
  entered: string
  known: string
  coordinates: { lat: number; lon: number }
}

export type CurrentValuesResult = {
  given: string
  known: string
}

export function KnownAddressModalLink({
  addressName,
  projectCountry,
  getCurrentValues,
  getGivenIsDirty,
  onSubmit
}: {
  addressName: AddressName
  projectCountry: string
  getCurrentValues: () => CurrentValuesResult
  getGivenIsDirty: () => boolean
  onSubmit: (result: KnownAddressResult) => void
}) {
  const [knownAddressModalOpen, setKnownAddressModalOpen] =
    useState<boolean>(false)

  const handleSubmit = useCallback(
    (result: KnownAddressResult) => {
      onSubmit(result)
      setKnownAddressModalOpen(false)
    },
    [onSubmit]
  )

  return (
    <>
      <Button
        type="link"
        size="small"
        tabIndex={-1}
        onClick={() => setKnownAddressModalOpen(true)}
        aria-label={`Edit Known ${addressName} Address`}
        style={{ textDecoration: 'underline' }}
      >
        Edit
      </Button>

      {knownAddressModalOpen && (
        <KnownAddressModal
          addressName={addressName}
          projectCountry={projectCountry}
          getGivenIsDirty={getGivenIsDirty}
          getCurrentValues={getCurrentValues}
          isOpen={true}
          onCancel={() => setKnownAddressModalOpen(false)}
          onSubmit={handleSubmit}
        />
      )}
    </>
  )
}
